import { render, staticRenderFns } from "./vipPanel.vue?vue&type=template&id=415c00fe&"
import script from "./vipPanel.vue?vue&type=script&lang=js&"
export * from "./vipPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports